import Util from '../common/Util.js';
import Page from '../common/Page.js';

import Videos from './Videos.js';
import Messages from './Messages.js';

export default class MyPage extends Page {

	constructor() {

		super();

		this.DOM.section = document.querySelector('.section');

		this.name = this.DOM.section.getAttribute('data-controller');

	}

	/*
	** init
	*/

	init() {

		// super
		super.init();

		// videos
		this.videos = new Videos();
		this.videos.load();

		// messages
		this.messages = new Messages();
		this.messages.load();

	}

	/*
	** scrollTo
	*/

	scrollTo (value) {

		Util.setScrollTop(value);

	}

	/*
	** enter
	*/

	enter() {

		// super
		super.enter();

		// class
		setTimeout( () =>
		{
			this.DOM.body.classList.add('body--page-start');

		}, 600);

		this.DOM.body.classList.add('body--page-enter');

	}

	/*
	** unload
	*/

	unload() {

		// super
		super.unload();


		// videos
		if (this.videos)
		{
			this.videos.unload();
			this.videos = null;
		}

		// messages
		if (this.messages)
		{
			this.messages.unload();
			this.messages = null;
		}

		// class
		this.DOM.body.classList.remove('body--page-enter');
		this.DOM.body.classList.remove('body--page-start');

	}

}